// extracted by mini-css-extract-plugin
export default {"card":"TalentPartnerCard_card__9Ityp","content":"TalentPartnerCard_content__40j4r","card-image":"TalentPartnerCard_card-image__ZpM2n","desc":"TalentPartnerCard_desc__PF1Tz"};